import React from "react";
import { TableFooter, TableRow, TableCell, IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

const CustomTableFooter = ({
  page = 0,
  rowsPerPage = 0,
  count = 0,
  onChangePage,
}) => {
  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={1000} style={{ borderBottom: "none" }}>
          <div className="d-flex justify-content-end py-2">
            <div className="d-flex justify-content-between align-items-center">
              <p className="m-0">
                {count > 0 ? rowsPerPage * page - rowsPerPage + 1 : 0} -{" "}
                {rowsPerPage * page > count ? count : rowsPerPage * page} of {count}
              </p>
              <IconButton
                aria-label="Previous page"
                disabled={page === 1}
                size="small"
                className="mx-6"
                onClick={() => onChangePage(page - 1)}
              >
                <ChevronLeft />
              </IconButton>
              <IconButton
                aria-label="Next page"
                disabled={Math.ceil(count / rowsPerPage) === page}
                size="small"
                onClick={() => onChangePage(page + 1)}
              >
                <ChevronRight />
              </IconButton>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default CustomTableFooter;
